import { useRef, type ReactNode } from 'react';
import { useMotion } from '@/hooks/useEditorialMotion';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';

interface Props { title: string; description: string; children: ReactNode; }

export default function SubpageShell({ title, description, children }: Props) {
  const introRef = useRef<HTMLElement>(null);
  useMotion(introRef, [title]);
  return (
    <div className="bg-background-50 overflow-x-hidden min-h-screen">
      <title>{`${title} | NOVA Hair Studio`}</title>
      <meta name="description" content={description} />
      <Header />
      <main>
        <section ref={introRef} className="bg-background-50 pt-32 md:pt-44 pb-12 md:pb-20">
          <div data-group className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-5 items-end">
            <h1 data-m="title" className="lg:col-span-7 font-heading font-semibold tracking-[-0.03em] leading-[1] text-[44px] md:text-[72px] text-foreground-950">{title}</h1>
            <p data-m="sub" data-at="0.12" className="lg:col-span-5 text-[16px] leading-relaxed text-foreground-700 max-w-md">{description}</p>
          </div>
        </section>
        {children}
      </main>
      <Footer />
    </div>
  );
}